<template>
    <div :class="groupClass">
        <label v-if="hasLabel" :class="labelClass" :for="id">{{ label }}</label>
        <div v-bind:class="inputContainerClass">
            <slot></slot>
        </div>
        <template v-if="hasError">
        <span v-for="(err, index) in error" :key="index" :class="errorSpanClass">{{err}}</span>
        </template>
    </div>
</template>

<script>
export default {

    name: 'FormGroup',

    props: {
        label: {},
        error: Array,
        id: String,
        bootstrap: {
            type: Boolean,
            default: true
        },
        hasLabel: {
            type: Boolean,
            default: true
        },
        formType: String,

        // Horizontal form
        labelWidth: {
            type: Number,
            default: 3
        },
        inputWidth: {
            type: Number,
            default: 9
        },
        inputOffset: {
            type: Number,
            default: 0
        },
    },

    computed: {
        hasError() {
            return this.error !== undefined;
        },
        groupClass() {
            let classes = [];
            if(this.bootstrap) { classes.push('form-group'); }
            if(this.hasError) { classes.push('has-error', 'has-feedback'); }
            return classes.join(' ');
        },
        labelClass() {
            let classes = [];
            if(this.formType == 'horizontal' && this.labelWidth > 0) { classes.push('col-sm-' + this.labelWidth); }
            if(this.bootstrap) { classes.push('control-label'); }
            return classes.join(' ');
        },
        inputContainerClass() {
            let classes = [];
            if(this.formType == 'horizontal' && this.inputWidth > 0) {
                classes.push('col-sm-' + this.inputWidth);
                if(this.inputOffset > 0) {
                    classes.push('col-sm-offset-' + this.inputOffset);
                } else if(!this.hasLabel) {
                    classes.push('col-sm-offset-' + (12-this.inputWidth));
                }
            }
            return classes.join(' ');
        },
        errorSpanClass() {
            let classes = ['help-block'];
            if(this.formType == 'horizontal' && this.inputWidth > 0) {
                classes.push('col-sm-'+this.inputWidth);
                if(this.inputOffset > 0) {
                    classes.push('col-sm-offset-' + this.inputOffset);
                } else {
                    classes.push('col-sm-offset-' + (12-this.inputWidth));
                }
            }
            return classes.join(' ');
        },
    },

}
</script>
